export default __webpack_public_path__ + "static/media/NEXT_ART_Regular.03e3e915.otf";